import { Navigate } from "react-router-dom";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

/**
 * @function PublicRoute
 * @description for PublicRoute
 * @returns JSX for PublicRoute
 */

const PublicRoute = ({ children }) => {
  const AuthReducer = useSelector((store) => store?.AuthReducer);
  const { accessToken = "" } = AuthReducer;
  const location = useLocation();
  if (accessToken && accessToken.length > 0) {
    return <Navigate to="/dashboard" state={{ from: location }} />;
  }
  return children;
};
export default PublicRoute;
